// Libraries
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// Components
import ThemeOne from "./components/theme-one/ThemeOne";
import ThemeTwoR from "./components/theme-two/ThemeTwoR";
import ThemeThree from "./components/theme-three/ThemeThree";
import RippleEffect from "./components/animation/RippleEffect";
import { ToastContainer } from "react-toastify";
import PaymentsPage, { PaymentCancelPage, PaymentStatusPage } from "./components/payments/PaymentsPage";
import DocumentChatPage from "./components/document-chat/DocumentChatPage";
// CSS
import "./styles/common.css";
import 'react-toastify/dist/ReactToastify.css';

function App() {
    const [visibleRipple, setVisibleRipple] = useState<boolean>(false);
    const [visibleRippleSend, setVisibleRippleSend] = useState<any>([]);
    const [position, setPosition] = useState<any>({ x: 0, y: 0 });

    /**
     * Ripple effect and position handling
     * */
    useEffect(() => {
        setVisibleRipple(visibleRippleSend.visible);
        setPosition({
            x: visibleRippleSend.x,
            y: visibleRippleSend.y
        });
    }, [visibleRippleSend]);

    return (
        <div>
        <RippleEffect visibleRipple={visibleRipple} position={position} />
        <ToastContainer />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/" element={<ThemeOne setVisibleRipple={setVisibleRippleSend} />}></Route>
                <Route path="/theme-two" element={<ThemeTwoR setVisibleRipple={setVisibleRippleSend} />}></Route>
                <Route path="/theme-three" element={<ThemeThree />}></Route>
                <Route path="/payments" element={<PaymentsPage />}></Route>
                <Route path="/document-chat" element={<DocumentChatPage />}></Route>
                <Route path="/payment" element={<Navigate to="/payments" replace />}></Route>
                <Route path="/subscriptions" element={<Navigate to="/payments" replace />}></Route>
                <Route path="/payment/success" element={<PaymentStatusPage />}></Route>
                <Route path="/payment/cancel" element={<PaymentCancelPage />}></Route>
                <Route path="/subscription/success" element={<PaymentStatusPage />}></Route>
                <Route path="/subscription/cancel" element={<PaymentCancelPage />}></Route>
            </Routes>
        </BrowserRouter>
    </div>
    );
}

export default App;
